module.exports = __webpack_public_path__ + "img/collection-weddingRingsNaturalBeige@2x.337a8fc.webp";